import clsx from 'clsx'
import styles from './Icon.module.scss'
import type { IIconProps, SpriteSections } from './types'

export const Icon = <T extends SpriteSections>({
  iconStyles,
  name,
  section,
  size = '40',
}: IIconProps<T>) => {
  return (
    <svg className={clsx(styles[`iconSize-${size}`], iconStyles)}>
      <use xlinkHref={`/sprites/${section}.svg#${name}`} />
    </svg>
  )
}
